controllers.controller('PasswordAssistanceController', [
    '$scope', '$state', '$ionicLoading', '$q',
    'config', 'constants', 'ErrorService', 'LocaleService', 'API',
    function ($scope, $state, $ionicLoading, $q,
              config, Const, ErrorService, LocaleService, API) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.assistance = {
            email: ''
        };

        $scope.validator = {
            email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        };

        $scope.navigate = function (state) {
            $state.go(state);
        };


        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            actionText: LocaleService.translation.try_again,
            back: ''
        };

        $scope.modal = angular.copy(modalDefaults);

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'PasswordAssistanceController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'accountNotExists',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.restorePassword = function () {
            $ionicLoading.show();

            API.forgotPassword($scope.assistance)
                .then(checkResponse)
                .then(function () {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.email_sent;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.isError = false;
                    $scope.modal.state = true;
                    $scope.modal.textContent = LocaleService.translation.password_changed_text;
                    $scope.modal.back = "login";
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = error && error.code && LocaleService.translation.messages[error.code] || LocaleService.translation.messages.Err600;
                    $scope.modal.textContent = error && error.code && error.code.toString().match(/^Err6\d\d$/) ? LocaleService.translation.messages.general_error_text : '';
                    $scope.modal.isError = true;
                    $scope.modal.state = true;
                })
        }

    }]);
